import * as React from "react";
import { Lightbox } from "../../../../../../../react-core/Html/Components/Lightbox";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import {TaxYearHelper} from "../../Helpers/TaxYearHelper";

interface IIsaDeclarationProps extends IProcessComponentProps {}

interface IIsaDeclarationState {
    show: boolean;
}

export class IsaDeclaration extends ProcessComponent<IIsaDeclarationProps, IIsaDeclarationState> {
    constructor(props: any) {
        super(props);
        this.state = {
            show: false,
        };
    }

    public render(): JSX.Element {
        const tye2024 = TaxYearHelper.GetCurrentTaxYear() >= 2024
        return (
            <>
                <h2 className="mb-22">ISA Stocks & Shares</h2>

                <p>
                    By clicking on the “Next” button below, I confirm that my client has authorised me to instruct this
                    payment and/or transfer and to make the ISA{" "}
                    <span
                        className="hyperlink"
                        onClick={() => {
                            this.setState({ show: true });
                        }}
                    >
                        declaration
                    </span>{" "}
                    on my client’s behalf. I understand that abrdn will send a confirmation letter to my client.
                </p>
                {this.state.show && (
                    <Lightbox
                        show={this.state.show}
                        title={""}
                        onClose={() => this.setState({ show: false })}
                        cssWrapper="is-default-lightbox is-wide"
                    >
                        <p>"For Stocks and Shares ISAs, each applicant must declare that:</p>
                        <ol className="ml-15">
                            <li className="mb-15">I am aged 18 years of age or over</li>
                            <li className="mb-15">All subscriptions made, and to be made, belong to me</li>
                            <li className="mb-15">
                                I have not subscribed and will not subscribe more than the overall subscription limit in
                                total to any combination of permitted ISAs in the same tax year
                            </li>
                            {tye2024 == false ?
                            <li className="mb-15">
                                I have not subscribed and will not subscribe to another stocks and shares ISA in the
                                same tax year that I subscribe to this stocks and shares ISA
                            </li> : null }
                            <li className="mb-15">
                                I am resident in the United Kingdom for tax purposes or, if not so resident, either
                                perform duties which, by virtue of Section 28 of the Income Tax (Earnings & Pensions)
                                Act 2003 (Crown employees serving overseas), are treated as being performed in the
                                United Kingdom, or I am married to, or in a civil partnership with, a person who
                                performs such duties. I will inform Standard Life Savings Limited if I cease to be so
                                resident or to perform such duties or be married to, or in a civil partnership with, a
                                person who performs such duties
                            </li>
                            <li className="mb-15">
                                The information given in relation to this application is correct to the best of my
                                knowledge and belief
                            </li>
                            <li className="mb-15">I agree to the ISA terms and conditions</li>
                            <li className="mb-15">
                                I authorise Standard Life Savings Limited to hold my cash subscriptions, ISA
                                investments, interest, dividends and any other rights and proceeds in respect of those
                                investments and any other cash, and to make on my behalf any claims to relief from tax
                                in respect of ISA investments.
                            </li>
                            <li className="mb-15">
                                I apply to subscribe to a Stocks and Shares ISA for the current tax year and each
                                subsequent year until further notice"
                            </li>
                        </ol>
                    </Lightbox>
                )}
            </>
        );
    }
}
